import { createClassName } from 'utils/createClassName';

import './dashboardPasswordEditorStyles.scss';

export const createDashboardPasswordEditorClassName = createClassName(
  'dashboard-password-editor'
);
